import React from 'react';

import * as S from './styles';

import { ProductCorePropertiesListProps } from './types';

const ProductCorePropertiesList = ({
  className,
  properties,
  toneDown,
  maxrows,
  size,
  showAsList,
  truncate,
}: ProductCorePropertiesListProps) => (
  <S.PropertyList
    className={className}
    toneDown={toneDown}
    maxRows={maxrows}
    size={size}
    showAsList={showAsList}
  >
    {properties ? (
      properties
        .filter(v => v)
        .map(value => (
          <S.Property key={value} showAsList={showAsList} truncate={truncate}>
            {value}
          </S.Property>
        ))
    ) : (
      <S.PlaceholderProperty toneDown={toneDown} size={size} />
    )}
  </S.PropertyList>
);

ProductCorePropertiesList.defaultProps = {
  properties: undefined,
  toneDown: false,
  maxrows: undefined,
  size: 'large',
  showAsList: false,
  className: undefined,
  truncate: false,
};

export default ProductCorePropertiesList;
